import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { Minus } from "lucide-react";
 * // Use <Minus /> instead
 */
export const RemoveIcon = createSVGWrapper(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm2.95-13.364a1 1 0 0 1 1.414 1.414L13.414 12l2.95 2.95a1 1 0 0 1-1.414 1.414L12 13.414l-2.95 2.95a1 1 0 0 1-1.414-1.414l2.95-2.95-2.95-2.95A1 1 0 0 1 9.05 7.636l2.95 2.95 2.95-2.95Z"
    clipRule="evenodd"
  />
);
